/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `AccountBalanceIconProps` interface defines the properties for the AccountBalanceIcon component.
 */
interface AccountBalanceIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "account_balance" — outlined, weight 300.
 * Classical building icon for the Historical tour category.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const AccountBalanceIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'AccountBalanceIcon',
    width
}: AccountBalanceIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M230-280v-300h60v300h-60Zm220 0v-300h60v300h-60ZM110.77-140v-60h738.46v60H110.77ZM670-280v-300h60v300h-60ZM110.77-660v-56.92L480-897.69l369.23 180.77V-660H110.77Zm141.84-60h454.78-454.78Zm0 0h454.78L480-830 252.61-720Z" />
    </svg>
);

AccountBalanceIcon.displayName = 'AccountBalanceIcon';